import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SbEditorToolsModule } from '../sb-editor-tools/sb-editor-tools.module';
import { PluginsModule } from './plugins/plugins.module';
import { SbEditorSidebarComponent } from './sb-editor-sidebar.component';
import { HeaderModule } from './header/header.module';
import { PopupscomparatorModule } from './popupscomparator/popupscomparator.module';
import { ExternModule } from './extern/extern.module';
import { MapModule } from './map/map.module';
import { ColorInterfaceModule } from '../sb-editor-tools/colorinterface/colorinterface.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [SbEditorSidebarComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SbEditorToolsModule,
    PluginsModule,
    MapModule,
    ExternModule,
    HeaderModule,
    PopupscomparatorModule,
    ColorInterfaceModule,
  ],
  providers: [],
  exports: [SbEditorSidebarComponent],
})
export class SbEditorSidebarModule {}
